import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { Message } from 'element-ui';
import {queryReturnInfo} from "@/api/oms/return-order";

export default extend(dialog, {
	namespaced: true,
	state: {
		returnSerialNumber: 0,
		detail: {},
	},
	actions: {
		async afterOpenDialog({ dispatch, commit, state }, payload) {
			const { returnSerialNumber } = state;
			await wait(dispatch, 'sms.return-order.detail', async function () {
				let response =  await queryReturnInfo({returnSerialNumber});
				if (response.data) {
					commit('save', {
						detail: response.data
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							dispatch('closeDialog')
						}
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/return-order/detail.js